import { Dispatch } from 'redux';
import FacebookOauthTokensController from '../controllers/FacebookOauthTokensController';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class FBOauthTokensCRUDActions extends CrudActionContainer {
  constructor() {
    super('FB_OAUTH_TOKENS');
  }

  create({ facebookPageId, token }) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const entity = await FacebookOauthTokensController.create({
          facebookPageId,
          token,
        });
        dispatch({
          type: this.retrievedAction,
          entity,
        });
        return entity;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        this.unbusy();
      }
    };
  }
  retrieveAll({ facebookPageId }) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrievedAllAction));
      let entities: Awaited<
        ReturnType<typeof FacebookOauthTokensController.getAll>
      >;
      try {
        entities = await FacebookOauthTokensController.getAll({
          facebookPageId,
        });
        dispatch({
          type: this.retrievedAllAction,
          entities,
        });
        return entities;
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        this.unbusy();
      }
    };
  }

  disable({ facebookPageId }) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        await FacebookOauthTokensController.disable({ facebookPageId });
        dispatch({ type: this.deleteAction });
      } catch (error) {
        return commonHandler(dispatch)(error);
      } finally {
        this.unbusy();
      }
    };
  }
}

export const fbOauthTokensCRUDActions = new FBOauthTokensCRUDActions();

export const useFBOauthTokensCRUDActions = getActionHookBuilder(
  fbOauthTokensCRUDActions,
  ['retrieveAll', 'create', 'disable'],
);
